const Hamburger = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.25 17.6342C4.0375 17.6342 3.85942 17.5623 3.71575 17.4185C3.57192 17.2748 3.5 17.0967 3.5 16.884C3.5 16.6715 3.57192 16.4934 3.71575 16.3497C3.85942 16.2062 4.0375 16.1345 4.25 16.1345H19.75C19.9625 16.1345 20.1406 16.2063 20.2843 16.35C20.4281 16.4938 20.5 16.6721 20.5 16.8847C20.5 17.0972 20.4281 17.2753 20.2843 17.419C20.1406 17.5625 19.9625 17.6342 19.75 17.6342H4.25ZM4.25 12.7497C4.0375 12.7497 3.85942 12.6778 3.71575 12.534C3.57192 12.3902 3.5 12.212 3.5 11.9995C3.5 11.7868 3.57192 11.6087 3.71575 11.4652C3.85942 11.3216 4.0375 11.2497 4.25 11.2497H19.75C19.9625 11.2497 20.1406 11.3217 20.2843 11.4655C20.4281 11.6093 20.5 11.7875 20.5 12C20.5 12.2127 20.4281 12.3907 20.2843 12.5342C20.1406 12.6779 19.9625 12.7497 19.75 12.7497H4.25ZM4.25 7.86498C4.0375 7.86498 3.85942 7.79315 3.71575 7.64948C3.57192 7.50565 3.5 7.3274 3.5 7.11473C3.5 6.90223 3.57192 6.72415 3.71575 6.58048C3.85942 6.43698 4.0375 6.36523 4.25 6.36523H19.75C19.9625 6.36523 20.1406 6.43715 20.2843 6.58098C20.4281 6.72465 20.5 6.90282 20.5 7.11548C20.5 7.32798 20.4281 7.50607 20.2843 7.64973C20.1406 7.79323 19.9625 7.86498 19.75 7.86498H4.25Z"
        fill="#0A0A0A"
      />
    </svg>
  );
};
export default Hamburger;
